/** Promo ad upload limits (images vs videos). */
export const MAX_IMAGE_UPLOAD_MB = 100;
export const MAX_VIDEO_UPLOAD_MB = 100;

const MAX_IMAGE_BYTES = MAX_IMAGE_UPLOAD_MB * 1024 * 1024;
const MAX_VIDEO_BYTES = MAX_VIDEO_UPLOAD_MB * 1024 * 1024;

export function isVideoFile(file) {
  return Boolean(file?.type?.startsWith("video/"));
}

export function getPromoUploadMaxBytes(file) {
  return isVideoFile(file) ? MAX_VIDEO_BYTES : MAX_IMAGE_BYTES;
}

export function getPromoUploadLimitLabel(file) {
  return `${isVideoFile(file) ? MAX_VIDEO_UPLOAD_MB : MAX_IMAGE_UPLOAD_MB} MB`;
}

/** @returns {{ ok: true } | { ok: false, message: string }} */
export function validatePromoUploadFile(file) {
  if (!file) return { ok: false, message: "No file selected" };
  const maxBytes = getPromoUploadMaxBytes(file);
  if (file.size > maxBytes) {
    return {
      ok: false,
      message: `${file.name} exceeds ${getPromoUploadLimitLabel(file)} limit.`,
    };
  }
  return { ok: true };
}
